<template>
  <v-dialog scrollable max-width="1200px" v-model="showDialog">
    <template v-slot:activator="{ on }">
      <div class="my-2">
        <v-btn v-on="on" @click="cargar">
          <v-icon left>mdi-plus</v-icon>
          Agregar Clipboard
        </v-btn>
      </div>
    </template>
    <v-card v-on:paste="paste">
      <v-card-title>
        <h4>Agregar macheo</h4>
      </v-card-title>
      <v-card-text>
        <v-form ref="form" v-model="validForm">
          <v-autocomplete
            label="Origen"
            v-model="origen"
            :items="['BMAT','RBT']"
            no-data-text="Ingrese un origen"
            :rules="[rules.required]"
            autofocus
          ></v-autocomplete>

          <v-text-field
            type="text"
            label="Nombre"
            max="30"
            :rules="[rules.required, rules.counter30]"
            v-model="nombre"
          />
          <v-textarea
            type="text"
            rows="2"
            label="Descripcion"
            :rules="[rules.required]"
            v-model="descripcion"
          />
        </v-form>
        <h3>Vista previa de los datos importados</h3>
        <v-data-table
          dense
          :headers="headers"
          :items="itemsPreview"
          hide-default-footer
        >
          <!-- <template v-slot:[`item.actions`]="props">
            <v-btn
              v-if="props"
              small
              >eliminar</v-btn
            >
            <v-btn
              >Liquidar</v-btn
            >
          </template> -->
        </v-data-table>
        Filas: {{ this.items.length }}
        <span class="red--text" v-if="errorMessage">{{ errorMessage }}</span>
        <span class="blue--text" v-if="message">{{ message }}</span>
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions>
        <v-btn color="info" @click="volver">Volver</v-btn>
        <v-btn @click="pasteBtn">Pegar</v-btn>
        <v-btn
          :disabled="!validForm || loading || items.length == 0"
          color="warning"
          @click="procesar"
          :loading="loading"
          >Procesar</v-btn
        >
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import Vue from "vue";
import axios from "axios";
import numeral from "numeral";

export default Vue.extend({
  props: ["id", "celular"],
  data() {
    return {
      loading: false,
      showDialog: false,
      origen: 'BMAT',
      nombre: "",
      descripcion: "",
      errorMessage: "",
      message: "",
      items: [],
      itemsPreview: [],
      filas: new Map(),
      headers: [
        { text: "Obra", value: "nombreObra" },
        { text: "Artistas", value: "artistas" },
        { text: "Autores", value: "autores" },
        { text: "CodigoSGS", value: "codWorkSq" },
        { text: "ID", value: "origenId" },
        { text: "", value: "actions" },
      ],
      rules: {
        required: (value) => !!value || "Requerido.",
        counter: (value) =>
          (value && value.length <= 100) || "Maximo 100 caracteres",
        counter30: (value) =>
          (value && value.length <= 30) || "Maximo 30 caracteres",
      },
      validForm: false,
    };
  },
  mounted() {
    // document.body.addEventListener("paste", function (e) {
    //   var clipboardData, oData;
    //   e.stopPropagation();
    //   e.preventDefault();
    //   // Get pasted data via clipboard API
    //   clipboardData = e.clipboardData || window.clipboardData;
    //   console.log("clipboardaa", clipboardData);
    //   oData = clipboardData.getData("text");
    //   oData.split("\n").forEach(function (line) {
    //     let item = {};
    //     if (line) {
    //       let cells = line.split("\t");
    //       item.obra = cells[0];
    //       item.autores = cells[1];
    //     }
    //     this.items.push(item);
    //   });
    // });
    // navigator.clipboard
    //   .readText()
    //   .then((text) => {
    //     console.log("Pasted content: ", text);
    //   })
    //   .catch((err) => {
    //     console.error("Failed to read clipboard contents: ", err);
    //   });
  },
  methods: {
    cargar() {
      this.nombre = '';
      this.descripcion = '';
      this.errorMessage = '';
      this.items = [];
      this.itemsPreview = [];
    },
    paste(e) {
      this.clearMessages();

      //this.items = [];
      //this.itemsPreview = [];
      let clipboardData, text;
      e.stopPropagation();
      e.preventDefault();

      // Get pasted data via clipboard API
      clipboardData = e.clipboardData || window.clipboardData;
      console.log("clipboardaa", clipboardData);
      text = clipboardData.getData("text");
      this.cargarItems(text);
    },
    cargarItems(text) {
      
      text.split("\n").forEach((line) => {
        if (line) {
          let item = {};
          let cells = line.split("\t");
          item.nombreObra = cells[0];
          item.artistas = cells[1];
          item.autores = cells[2];
          if (cells[3]) {
            let codWorkSq = cells[3]
              .replace(/\./g, "")
              .replace(/,/g, "")
              .replace(/ /g, ""); //eliminamos espacios, puntos y comas
            if (!isNaN(codWorkSq) && codWorkSq > 6000000) {
              item.codWorkSq = codWorkSq;
            }
          }
          item.origenId = cells[4].trim();
          item.origen = this.origen;
          item.estado = "Pendiente";
          this.filas.set(item.origenId,item);
        }
        //this.items.push(item);
      });
      this.items = Array.from(this.filas.values());
      this.itemsPreview = this.items.slice(0, 5);
    },
    close() {
      this.$refs.form.reset();
      this.showDialog = false;
    },
    volver() {
      this.showDialog = false;
    },
    pasteBtn() {
      this.items = [];
      this.itemsPreview = [];

      this.clearMessages();

      navigator.clipboard
        .readText()
        .then((text) => {
          this.cargarItems(text);
        })
        .catch((err) => {
          // This can happen if the user denies clipboard permissions:
          console.error("Could not copy text: ", err);
        });
    },
    procesar() {
      this.message = "Procesando, favor aguarde . . .";
      this.errorMessage = "";
      let error = false;

      //Verificamos que no existan obra y/o id null
      this.items.forEach((m) => {
        if (!m.nombreObra || !m.origenId) {
          this.message = "";
          this.errorMessage = "existen obras o ID en blanco";
          error = true;
          return;
        }
        m.origen = this.origen;
        m.estado = 'Pendiente';
      });

      if (error) return;

      this.loading = true;

      const grupoMacheo = {nombre: this.nombre, descripcion: this.descripcion, origen: this.origen, macheos: this.items};
      axios
        .post("/macheo/procesarListaMacheo", grupoMacheo)
        .then((res) => {
          this.clearMessages();
          console.log(res);
          this.items = res.data.macheos;
          this.loading = false;
          this.$emit("nuevoGrupoMacheo");
          this.close();
        })
        .catch((err) => {
          console.log(err);
          this.message = '';
          this.errorMessage = err.response.data
          this.loading = false;
        });

      //PASO1
      //Eliminamos los origenId que ya exiten
      // let promises = [];
      // this.items.forEach(m => {
      //   promises.push(axios.get('/macheo/existsMacheosByOrigenId?origenId=' + m.origenId)
      //     .then(res => {
      //       console.log(res);
      //       m.estado = 'pre-macheado'
      //     })
      //     .catch(err => {
      //       console.log(err);
      //     })
      //   )
      // });

      // this.loading = false;

      // Promise.all(promises).then(() => {
      //   console.log('***********************',this.items)
      //   console.log(this.items.filter(i => i.estado != 'pre-macheado'));
      // })

      /*
      axios
        .put("/macheo/nuevo", {
          nombre: this.nombre,
          descripcion: this.descripcion,
          archivoNombre: this.fileName,
          archivoId: this.fileId,
        })
        .then((response) => {
          this.loading = false;
          this.message = "";
          console.log(response);
          this.$emit("nuevoGrupoMacheo");
          this.close();
        })
        .catch((err) => {
          this.message = "";
          this.loading = false;
          console.log(err);
          if (err.response.data) {
            this.errorMessage = err.response.data;
          } else {
            this.errorMessage = "Error";
          }
        });
        */
    },
    clearMessages() {
      this.errorMessage = "";
      this.message = "";
    },
  },
  filters: {
    numberFormat(value) {
      if (value) {
        return numeral(value).format("#,##0"); // displaying other groupings/separators is possible, look at the docs
      }
    },
  },
  components: {},
});
</script>
